var map = {
	"./bg130.png": 47603,
	"./br/PT/S1/bg130.png": 15710,
	"./in/EN/S1/bg130.png": 23157,
	"./ph/EN/S1/bg130.png": 23842,
	"./vn/VI/S1/bg130.png": 50390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58716;